var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialogTable',{attrs:{"title":"插入属性","btnType":"text","btnText":"插入属性","data":_vm.customfieldIdList,"option":_vm.option},on:{"open":_vm.onOpen,"row-click":_vm.rowClick,"submit":_vm.onSubmit},scopedSlots:_vm._u([{key:"menu",fn:function(ref){
var row = ref.row;
return [_c('color-text-btn',[_vm._v(_vm._s(_vm.getTitle(row)))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }